import { Button } from "@root/shared/components/Button";
import { type ComponentProps, type FC } from "react";
import { type PlanAndImageInfoProps } from "@clientFrontend/features/publication/components/ClientImageLibraryModal/type";
import * as styles from "./styles.css";

type FooterContentPlanAndImageInfoProps = Pick<
  PlanAndImageInfoProps,
  "currentBasicPlanName" | "userDisplayableImagesCount"
> & {
  selectedImagesCount: number;
};

type Props = {
  buttonProps: ComponentProps<typeof Button>;
  planAndImageInfoProps: FooterContentPlanAndImageInfoProps;
};

export const PlanAndImageInfoFooterContent: FC<Props> = ({
  buttonProps,
  planAndImageInfoProps,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.planInfo}>
          <p className={styles.planText}>
            現在のプラン: {planAndImageInfoProps.currentBasicPlanName}
          </p>
          <strong className={styles.selectedImageText}>
            選択中の画像 {planAndImageInfoProps.selectedImagesCount}/
            {planAndImageInfoProps.userDisplayableImagesCount}枚
          </strong>
        </div>
        <div className={styles.settingAlbumExplanation}>
          <p>※最大30枚まで設定可能ですが、掲載できる画像枚数は契約プランに準じます。</p>
          <p>※3枚以上の設定が必要です。</p>
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <Button {...buttonProps} theme="primary">
          画像を設定する
        </Button>
      </div>
    </div>
  );
};
